export default __webpack_public_path__ + "src/images/ball/2-72e0ef.png";